var _path, _path2, _mask, _g, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#00207F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 32L8.26452 33.6039L8.43639 31.247L6.10034 30.8901L8.0502 29.555L6.87273 27.506L9.13229 28.1981L10.0001 26L10.8678 28.1981L13.1274 27.506L11.9499 29.555L13.8998 30.8901L11.5637 31.247L11.7356 33.6039L10.0001 32Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "#00207F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L0 17M10 10L20 3L10 10Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L20 17M10 10L0 3L10 10Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L20 17M10 10L0 3L10 10Z",
    stroke: "#D10D24",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L0 17M10 10L20 3L10 10Z",
    stroke: "#D10D24",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.5H20.5V11.5H11.5V20.5H8.5V11.5H-0.5V8.5H8.5V-0.5H11.5V8.5Z",
    fill: "#D10D24",
    stroke: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 35L29.1323 35.8019L29.2182 34.6235L28.0502 34.445L29.0251 33.7775L28.4364 32.753L29.5661 33.099L30 32L30.4339 33.099L31.5637 32.753L30.975 33.7775L31.9499 34.445L30.7819 34.6235L30.8678 35.8019L30 35Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 22.5L32.4122 22.809L32.5245 22.1545L32.049 21.691L32.7061 21.5955L33 21L33.2939 21.5955L33.9511 21.691L33.4755 22.1545L33.5878 22.809L33 22.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 16L35.1323 16.8019L35.2182 15.6235L34.0502 15.445L35.0251 14.7775L34.4364 13.753L35.5661 14.099L36 13L36.4339 14.099L37.5637 13.753L36.975 14.7775L37.9499 15.445L36.7819 15.6235L36.8678 16.8019L36 16Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 18L23.1323 18.8019L23.2182 17.6235L22.0502 17.445L23.0251 16.7775L22.4364 15.753L23.5661 16.099L24 15L24.4339 16.099L25.5637 15.753L24.975 16.7775L25.9499 17.445L24.7819 17.6235L24.8678 18.8019L24 18Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 7L29.1323 7.80194L29.2182 6.62349L28.0502 6.44504L29.0251 5.77748L28.4364 4.75302L29.5661 5.09903L30 4L30.4339 5.09903L31.5637 4.75302L30.975 5.77748L31.9499 6.44504L30.7819 6.62349L30.8678 7.80194L30 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAud);
export default __webpack_public_path__ + "static/media/aud.22d5e539a7cfacf8bd37224b3049afad.svg";
export { ForwardRef as ReactComponent };